import { InjectionToken } from '@angular/core';
import { IRxStore } from '../../store';

import { IConfigurationModel } from './state';

export const DEFAULT_CONFIGURATION = new InjectionToken<IConfigurationModel>('configuration options');

export const CORE_CONFIGURATION_STORE = new InjectionToken<IRxStore<IConfigurationModel>>('core configuration store');
